import { createSelector } from 'selectors'

import { constant } from './constant'

export const getSpectrum = () =>
	createSelector<NodeListOf<HTMLInputElement>>({ selector: constant.selector.target }, true)

export const getSpectrumComponents = () => ({
	target: getSpectrum(),
})
